import React, { Component, ReactNode } from 'react';
import Logo from './Logo';

import styles from './styles.less';

interface Props {
	children: ReactNode | null;
	panel: ReactNode | null;
	bottomPanel: ReactNode | null;
	innerContainerStyle?: React.CSSProperties;
	/** Lets the navigation scroll away with the page instead of staying pinned. */
	inFlow?: boolean;
}

export default class Navigation extends Component<Props> {
	static defaultProps = {
		children: null,
		panel: null,
		bottomPanel: null,
	};

	render() {
		const { children, innerContainerStyle, panel, bottomPanel, inFlow } = this.props;
		const headerClassName = bottomPanel ? styles.headerWithBottomPanel : styles.header;

		return (
			<header data-app-navigation className={inFlow ? `${headerClassName} ${styles.headerInFlow}` : headerClassName}>
				<div className={styles.in} style={innerContainerStyle}>
					<div className={styles.headerContent}>
						<div className={styles.navigation}>
							<Logo />
							<ul className={styles.navigationList}>{children}</ul>
						</div>
						<div className={styles.headerUser}>{panel}</div>
					</div>
				</div>
				{bottomPanel}
			</header>
		);
	}
}
